import React from 'react'
import { storiesOf } from '@storybook/react'

import GameCardContentInvite from 'components/GameCard/components/GameCardContentInvite'

storiesOf('GameCard/GameCardContentInvite', module)
  .addDecorator((story) => (
    <>
      <div style={{ padding: 32, backgroundColor: '#FFF' }}>{story()}</div>
      <div style={{ padding: 32, backgroundColor: '#FFF', width: 320, borderTop: '1px solid #EEE' }}>{story()}</div>
    </>
  ))
  .add('default', () => (
    <GameCardContentInvite
      photoUrl="https://randomuser.me/api/portraits/thumb/men/79.jpg"
      name="LouisCKT"
      entryFee={50}
    />
  ))
